export default __webpack_public_path__ + "static/media/Poppins-LightItalic.5ccd942a.ttf";